import {useState, useEffect} from "react";
import moment from "moment";
import {shouldEnableLaunchButton} from "../helpers/SessionHelper";

export function useSessionStatus(selectedEvent, currentTime) {
    const [sessionStatusInfo, setSessionStatusInfo] = useState("");
    const [isSessionStarted, setIsSessionStarted] = useState(false);
    const [isSessionEnded, setIsSessionEnded] = useState(false);
    const [canLaunchSession, setCanLaunchSession] = useState(false);

    useEffect(() => {
        if (!selectedEvent) {
            return;
        }

        const now = moment(currentTime);

        setSelectedSessionStatusInfo(selectedEvent, now);
        setIsSessionStarted(now.isAfter(selectedEvent.from));
        setIsSessionEnded(now.isAfter(selectedEvent.to));

        const canEnableLaunchButton = shouldEnableLaunchButton(selectedEvent, now);
        setCanLaunchSession(canEnableLaunchButton);
    }, [selectedEvent, currentTime]);

    const setSelectedSessionStatusInfo = (selectedEvent, now) => {
        if (now.isAfter(selectedEvent.to)) {
            setSessionStatusInfo('Session Finished');
        } else if (now.isAfter(selectedEvent.from)) {
            setSessionStatusInfo('Session in Progress');
        } else {
            setSessionStatusInfo('Session Starts In');
        }
    };

    return {
        sessionStatusInfo,
        isSessionStarted,
        isSessionEnded,
        canLaunchSession
    };
}
